import LockIcon from '@mui/icons-material/Lock';
import { Box, Card, CardMedia, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import Button from "@mui/material/Button";
import Vimeo, { EndEvent, PauseEvent, PlayEvent } from "@u-wave/react-vimeo";
import VimeoPlayer from "@vimeo/player";
import parse from 'html-react-parser';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router";
import { Scrollbar } from 'react-scrollbars-custom';
import { dummyPgPromo } from "../../dummy/pgPromo";
import { isDrillsPath, removeDomainFromUrl, toggleAutoplay } from "../../helpers/utils";
import { useAccelerator } from "../../hooks/acceleratorDataProvider";
import { useCoachingBannerVisibility } from "../../hooks/useCoachingBannerVisibility";
import { useVideoProgressTracking } from "../../hooks/useVideoProgressTracking";
import { Accelerator } from "../../interfaces/accelerator";
import { Course } from "../../interfaces/course";
import { CurrentLesson } from "../../interfaces/currentLesson";
import { Lesson } from "../../interfaces/lesson";
import { Link } from "../../interfaces/link";
import { Promo } from "../../interfaces/promo";
import { CHAMPION_PASS_PROMO } from "../coursePlayer/coursePlayer";
import PopUpDialog from "../dialogs/popUpDialog/popUpDialog";
import PopUpDialogMobile from "../dialogs/popUpDialog/popUpDialogMobile";
import RecordResultsDialog from "../dialogs/recordResultsDialog";
import ResultsDialog from "../dialogs/resultsDialog";
import UpNext from "../dialogs/upNextPlaylist/upNext";
import {
  clickProduct,
  lessonVideoCompleteEvent,
  pausedDrillVideoEvent,
  pausedVideoEvent,
  startedDrillVideoEvent,
  startedVideoEvent,
  viewChampionPassModal,
  viewProduct,
  videoAutoplayToggleEvent,
  replayLessonEvent,
  totalTimeWatched
} from "../mixPanelEvents/mixPanelEvents";
import Playlist from "../playlist/playlist";
import styles from './player.module.css';
import NextLessonModal from '../dialogs/nextLessonModal/nextLessonModal';
import Spinner from '../spinner';

const MOVE_TO_NEXT_LESSON: string = "Move to Next Lesson?";
const MOVE_TO_NEXT_ACCELERATOR: string = "Move to Next Accelerator?";
const MOVE_TO_NEXT_LESSON_MOBILE: string = "Move to Next Lesson?";
const MOVE_TO_NEXT_ACCELERATOR_MOBILE: string = "Move to<br> Next Accelerator?";

const RECORD_DRILL_RESULTS: string = "Start Recording Drill Results?";
const RECORD_DRILL_RESULTS_MOBILE: string = "Start Recording<br> Drill Results?";

const ACCELERATOR_IDS_WITH_EVALUATION = [113251, 113252, 113256, 113254];
const PUTTING_LESSON_ID = 17900;
const PUTTING_LEFT_LESSON_ID = 17905

const COURSE_ONE_LESSON_ID = 25308;
const COURSE_TWO_LESSON_ID = 25320;
const COURSE_THREE_LESSON_ID = 25334;
const COURSE_FOUR_LESSON_ID = 25354;
const COURSE_FIVE_LESSON_ID = 25365;

const BALL_STRIKING_ID = 113256;
const FIRST_COURSE_ID = 25298;
const SECOND_COURSE_ID = 25309;
const THIRD_COURSE_ID = 25323;
const FOURTH_COURSE_ID = 25344;
const FIFTH_COURSE_ID = 25355;

// const BALL_STRIKING_ID = 85298;
// const FIRST_COURSE_ID = 25344;
// const SECOND_COURSE_ID = 25355;
// const THIRD_COURSE_ID = 2573;
// const FOURTH_COURSE_ID = 2575;
// const FIFTH_COURSE_ID = 2576;
//
// const ACCELERATOR_IDS_WITH_EVALUATION = [85293, 85294, 85298, 85296];
// const PUTTING_LESSON_ID = 17900;
// const PUTTING_LEFT_LESSON_ID = 17905
// const COURSE_ONE_LESSON_ID = 25354;
// const COURSE_TWO_LESSON_ID = 25365;
// const COURSE_THREE_LESSON_ID = 2586;
// const COURSE_FOUR_LESSON_ID = 2596;
// const COURSE_FIVE_LESSON_ID = 2607;

declare global {
    interface Window {
       courseId: number;
       courseName: string | undefined;
       championsPassTrialPricing: any;
       is_autoplay: string | undefined;
    }
 }

const Player = ({accelerator, currentLesson, quickDrillsHeight, firstTime,updateDrillLessons}: {
    accelerator: Accelerator,
    currentLesson: CurrentLesson,
    quickDrillsHeight: number,
    firstTime: boolean,
    updateDrillLessons?:any
}) => {
    const {accelerators} = useAccelerator();
    const navigate = useNavigate();
    const [videoLoaded, setVideoLoaded] = useState(false)
    const [lessonComplete, setLessonComplete] = useState<{
        lessonID: number,
        courseID: number,
        wasComplete: boolean
    }>({lessonID: 0, courseID: 0, wasComplete: false})
    const [showModal, setShowModal] = useState(false)
    const [showPopModal, setShowPopModal] = useState(false)
    const containerRef = useRef<null | HTMLDivElement>(null);
    const [modalTitle, setModalTitle] = useState("");
    const [modalBtnText, setModalBtnText] = useState("");
    const [modalAction, setModalAction] = useState(() => () => {
    });
    const [courses, setCourses] = useState<Course[]>([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const matches = useMediaQuery('(max-width:350px)');
    const isMobile767 = useMediaQuery('(max-width:767px)');
    const [isTrainingDrill, setIsTrainingDrill] = useState(false);
    const [scrollOffset, setScrollOffset] = useState(0);
    const [recordResult, setRecordResult] = useState(false);
    const [resultsDialogOpen, setResultsDialogOpen] = useState(false);
    const [recordLesson, setRecordLesson] = useState<Lesson>({
        content: "",
        lesson_type: "",
        link: {} as Link,
        url: "",
        drill_redirect_url:"",
        records: [],
        is_fav: false,
        video: {
            ID: 0,
            progress: 0,
            url: "",
            embed_url: "",
            duration: "",
            subheading: "",
            button_text: "",
            button_url: "",
            text_under_button: ""
        },
        ID: 0,
        complete: false,
        duration: "",
        name: "",
        is_pro_edition: false,
        drill: {
            game_rules: "",
            record_label: "",
            record_label_desc: "",
            scoring_system: "",
            subheading: ""
        },
        cta:{
            text:"",
            url:""
        },
        linkIcon: ""
    });
    const [hiding, setHiding] = useState(false);
    const [expanded, setExpanded] = useState<number | boolean>(false);
    const [playerHeight, setPlayerHeight] = useState(0);
    const [playerTitleHeight, setPlayerTitleHeight] = useState(0);
    const [recordResultHeightNumber, setRecordResultHeight] = useState(0);
    const recordResultHeightRef = useRef<null | HTMLDivElement>(null);
    const playerTitleRef = useRef<null | HTMLDivElement>(null);
    const [showPopupDialog, setShowPopupDialog] = useState(false);
    const [evaluationAnswer, setEvaluationAnswer] = useState("");
    const myRef = useRef<Scrollbar & HTMLDivElement>(null);
    const [addToPlaylist, setAddToPlaylist] = useState(false);
   const location = useLocation();
    const { isShowCoachBanner, updateLessonCounter } = useCoachingBannerVisibility();
    const vimeoPlayerRef = useRef<any>(null);
    const [totalVideoPlayerHeight, setTotalVideoPlayerHeight] = useState<number>(0);
    const [tmpHeaderHeight, setTmpHeaderHeight] = useState<number>(0);
    const [autoplayNextForCourse, setAutoplayNextForCourse] = useState(accelerator.is_autoplay);
    const switchEls = useRef<Array<HTMLDivElement | null>>([]);

    const [firstVisibleIndex, setFirstVisibleIndex] = useState<number | null>(null);
    const [isInitailVideoPlay, setisInitailVideoPlay] = useState(true);

    const [videoLessons, setVideoLessons] = useState<Lesson[]>([]);
    const [nextVideoLesson, setNextVideoLesson] = useState<Lesson | null>(null);
    const [prevVideoLesson, setPrevVideoLesson] = useState<Lesson | null>(null);
    const prevNextRef = useRef<null | HTMLDivElement>(null);
    const [prevNextHeight, setPrevNextHeight] = useState(0);

    const [previouslyWatchedLesson, setPreviouslyWatchedLesson] = useState<CurrentLesson>(currentLesson);

    const [isEndOfTheLesson, setIsEndOfTheLesson] = useState<number | boolean>(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
        (entries) => {
            const visible = entries
            .filter((e) => e.isIntersecting)
            .map((e) => ({
                index: Number(e.target.getAttribute('data-index')),
                top: e.boundingClientRect.top,
            }));

            if (visible.length > 0) {
            visible.sort((a, b) => a.top - b.top);
            setFirstVisibleIndex(visible[0].index);
            } else {
            setFirstVisibleIndex(null);
            }
        },
        {
            root: document.querySelector(isMobile ? '.playListLessons':'.Scrollable-Container'),
            rootMargin: '0px',
            threshold: [0, 0.001],
        }
        );

        switchEls.current.forEach((el) => {
        if (el) observer.observe(el);
        });

        return () => {
        observer.disconnect();
        };
    }, [autoplayNextForCourse]);

    const handleSwitchMount = (el: HTMLDivElement | null, index: number) => {
        switchEls.current[index] = el;
    };

    const handleAutoplayToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log("handleAutoplayToggle", event.target.checked)
        setAutoplayNextForCourse(event.target.checked);
        toggleAutoplay(event.target.checked, accelerator.ID);
        let status = event.target.checked ? 'On' : 'Off';
        videoAutoplayToggleEvent(status, currentLesson, accelerator, 'Playlist');
     };
     

    useEffect(() => {
        if(window.is_autoplay && window.is_autoplay.indexOf(""+accelerator.ID) !== -1) {
            setAutoplayNextForCourse(window.is_autoplay.indexOf("true") !== -1);
        } else {
            setAutoplayNextForCourse(accelerator.is_autoplay);
        }

    }, [accelerator, currentLesson])

    useEffect(() => {
        window.is_autoplay = ""+accelerator.ID+autoplayNextForCourse;
    }, [autoplayNextForCourse])

    const handleReplay = () => {
        if (!vimeoPlayerRef.current) {
            console.warn("Vimeo player ref is not ready");
            return;
        }
        const iframeEl = vimeoPlayerRef.current.player?.element;
        if (!iframeEl) {
            console.warn("Vimeo iframe element not found");
            return;
        }
        const player = new VimeoPlayer(iframeEl);
        player.setCurrentTime(0);
        player.play();
        let currentCourse = null;
        let currentCourseName = '';
        if (!currentLesson.courseID && !currentLesson.is_introduction) {
           currentCourse = courses.find((el) =>
              el.lessons.find((lesson) => lesson.ID === currentLesson.ID)
           );
        } else {
           currentCourse = courses.find((el) => el.ID === currentLesson.courseID);
        }
        if(currentCourse) {
           currentCourseName = currentCourse.name;
        }
        replayLessonEvent(currentLesson, accelerator);
    };

    useEffect(() => {
        if (currentLesson.name === "") {
            return;
        }
        const divEle = document.createElement("div");
        const divImg = document.createElement("img");
        const divParagraph = document.createElement("p");

        divImg.src = "https://www.performancegolf.com/wp-content/uploads/2023/11/Video-Icon.png"
        divImg.style.height = "100%";
        divImg.style.marginRight = "7px";
        const divTextContent = currentLesson.name + " (" + currentLesson.duration + ")";

        divEle.appendChild(divImg);
        divParagraph.textContent = divTextContent;
        divParagraph.style.marginBottom = "0";
        divParagraph.style.fontSize = "14px";
        divParagraph.style.color = "#fff";

        divEle.appendChild(divParagraph);
        divEle.style.padding = "8px";
        divEle.style.marginLeft = "20px";
        divEle.style.marginRight = "20px";
        divEle.style.background = "#000";
        divEle.style.display = "flex";
        divEle.style.opacity = "0";

        document.body.appendChild(divEle);
        requestAnimationFrame(() => {
            setTmpHeaderHeight(divEle.offsetHeight);
        });
        setTimeout(() => {
            divEle.remove();
        }, 3000);
    }, [currentLesson.name]);

    useEffect(() => {
        function getVimeoPlayerSize(): [number, number] {
            const width: number = window.innerWidth - 40;
            const height: number = width * 9 / 16;
            
            return [width, height];
        }
        const [width, height] = getVimeoPlayerSize();

        const currentBanner = document.querySelectorAll(`#accordion-header-${currentLesson.courseID}`)[1];
        const currentBannerHeight = currentBanner?.clientHeight ?? 90;

        if (accelerator.name === "Drills" && isMobile) {
            setExpanded(currentLesson.courseID);

            const playingLessonId = currentLesson.ID;
            const playingLessonElement = document.querySelector(`#lesson-element-${playingLessonId}`);

            if (playingLessonElement) {
                const elementTop = playingLessonElement.getBoundingClientRect().top + window.scrollY;
                const offset = height + tmpHeaderHeight + currentBannerHeight + (window.innerWidth < 316 ? 58 : 43);

                window.scrollTo({
                    top: elementTop - offset,
                    behavior: "smooth"
                });
            }
            return;
        }

        // if (isMobile && currentLesson.name !== "" && currentLesson.drill && Object.keys(currentLesson.drill).length > 0) {
        //     setExpanded(currentLesson.courseID);

        //     const playingLessonId = currentLesson.ID;
        //     const playingLessonElement = document.querySelector(`#lesson-element-${playingLessonId}`);

        //     if (playingLessonElement) {
        //         const elementTop = playingLessonElement.getBoundingClientRect().top + window.scrollY;
        //         const offset = height + currentBannerHeight;

        //         window.scrollTo({
        //             top: elementTop - offset,
        //             behavior: "smooth"
        //         });
        //     }
        //     return;
        // }

        if (isMobile) {
            setExpanded(currentLesson.courseID);

            const playingLessonId = currentLesson.ID;
            const playingLessonElement = document.querySelector(`#lesson-element-${playingLessonId}`);

            if (playingLessonElement) {
                const elementTop = playingLessonElement.getBoundingClientRect().top + window.scrollY;
                const offset = height + currentBannerHeight + tmpHeaderHeight - (isIOS() ? 40 : 0);

                window.scrollTo({
                    top: elementTop - offset,
                    behavior: "smooth"
                });
            }
        }
    }, [tmpHeaderHeight]);

    const isIOS = () => {
        const ua = navigator.userAgent;
        // legacy iOS (iPhone/iPad/iPod)
        if ( /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream ) {
            return true;
        }
        // iPadOS 13+ Safari detection
        if (/\bMacintosh\b/.test(ua) && navigator.maxTouchPoints > 1) {
            return true;
        }
        return false;
    };


    useEffect(() => {
        if (isMobile) {
            window.addEventListener("resize", (event) => {
               if (window.innerHeight > window.innerWidth) {
                  console.log("Orientation changed: Portrait");
                  changeViewMod(true);
               } else {
                  console.log("Orientation changed: Landscape");
                  changeViewMod(false);
               }
            });

            return () => {
               window.removeEventListener("resize", () => {});
            };
         }
    }, []);

    const changeViewMod = (currentViewport: boolean) => {
        if (!vimeoPlayerRef.current) {
           console.warn("Vimeo player ref is not ready");
           return;
        }

        const playerElement = vimeoPlayerRef.current.player?.element;
        if (playerElement) {
           const vmPlayer = new VimeoPlayer(playerElement);
           if (!currentViewport) {
            if (isIOS()) {
                vmPlayer.requestFullscreen().then(function() {
                    console.log('enter the fullscreen');
                }).catch(function(e) {
                    console.error(e);
                });
            } else {
                playerElement.classList.add(styles.enterTheFullScreen);
            }

           } else {
            if (isIOS()) {
                vmPlayer.exitFullscreen().then(function() {
                    console.log('exit the fullscreen');
                }).catch(function(e) {
                    console.error(e);
                });
            } else {
                playerElement.classList.remove(styles.enterTheFullScreen);
            }
           }
        }
    };

      const checkCurretViewMode = () => {
        let currentMod = window.innerWidth > window.innerHeight;
        if (currentMod && isMobile) {
           changeViewMod(false);
        }
      };

    useEffect(() => {
        setVideoLoaded(true);
    }, [currentLesson.content]);

    // useEffect(() => {
    //     if (!isMobile && expanded > 0) {
    //         setTimeout(() => {
    //             let scrollTop = 0;
    //             for (const course of accelerator.courses) {
    //                 if (course.ID === expanded)
    //                     break;
    //                 const header = document.getElementById('accordion-header-' + course.ID);
    //                 if (header) {
    //                     scrollTop += header.offsetHeight;
    //                 }
    //             }
    //             myRef.current?.scrollTo(0, scrollTop)
    //         }, 500)
    //     }
    //     // eslint-disable-next-line
    // }, [expanded]);


    useEffect(() => {
        setisInitailVideoPlay(false)
        if(currentWatchTime && currentWatchTime > 0) {
            totalTimeWatched(
            currentWatchTime,
            accelerator,
            previouslyWatchedLesson
            );
        }
        setPreviouslyWatchedLesson(currentLesson)
        if(autoplayNextForCourse) {
            setCurrentWatchTime(0);
            setIsVideoPlaying(true)    
        } else {
            setIsVideoPlaying(false)
        }
        window.courseId = currentLesson.courseID;
        window.courseName = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === currentLesson.ID))?.name
    }, [currentLesson]);

    const {onProgressUpdate} = useVideoProgressTracking(currentLesson, accelerator)


    useEffect(() => {
        const handleResize = () => {
            // @ts-ignore
            setPlayerHeight(containerRef.current.offsetHeight);
            if(prevNextRef.current) {
                setPrevNextHeight(prevNextRef.current.offsetHeight);
            } else {
                setPrevNextHeight(0);
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

   

    useEffect(() => {
        if (!prevNextRef.current) {
            setPrevNextHeight(0);
            return;
        }

        const height = prevNextRef.current.offsetHeight;
        setPrevNextHeight(height);
    }, [prevVideoLesson, nextVideoLesson]);

    useEffect(() => {
        setCourses(accelerator.courses);
        setExpanded(currentLesson.courseID);
        setShowModal(false);
        setShowPopupDialog(false);

        setVideoLessons(
            accelerator.courses.flatMap(course =>
                course.lessons.filter(
                lesson =>
                    lesson.lesson_type === "video"
                )
            )
        );
        
    }, [accelerator, currentLesson]);

    useEffect(() => {
        const currentVideoLessonIndex = videoLessons.findIndex(
            lesson => lesson.ID === currentLesson.ID
        );
        const prev =
            currentVideoLessonIndex > 0 ? videoLessons[currentVideoLessonIndex - 1] : null;
        const next =
            currentVideoLessonIndex !== -1 && currentVideoLessonIndex < videoLessons.length - 1
                ? videoLessons[currentVideoLessonIndex + 1]
                : null;
        setNextVideoLesson(next);
        setPrevVideoLesson(prev);
    }, [videoLessons, currentLesson]);

    useEffect(() => {
        setShowModal(false)
        setVideoLoaded(false);
        setShowPopupDialog(false);
        setIsTrainingDrill(currentLesson.drill !== undefined);
    }, [currentLesson]);

    useEffect(() => {
        if (playerTitleRef.current){
            setPlayerTitleHeight(playerTitleRef.current.offsetHeight);
        }
        if(recordResultHeightRef.current){
            setRecordResultHeight(recordResultHeightRef.current.offsetHeight)
        }
    }, [videoLoaded]);

    const openBallStrikingLesson = (evaluationAnswer: string) => {
        if (Number(accelerator.ID) === BALL_STRIKING_ID) {
            if (evaluationAnswer === "Push Slice" && currentLesson.courseID !== FIRST_COURSE_ID) {
                let course = accelerator.courses.find(course => course.ID === FIRST_COURSE_ID);
                if (course) {
                    navigate(removeDomainFromUrl(course.lessons[0].url))
                }
            } else if (evaluationAnswer === "Pull Slice" && currentLesson.courseID !== SECOND_COURSE_ID) {
                let course = accelerator.courses.find(course => course.ID === SECOND_COURSE_ID);
                if (course) {
                    navigate(removeDomainFromUrl(course.lessons[0].url))
                }
            } else if (evaluationAnswer === "Pull Hook" && currentLesson.courseID !== THIRD_COURSE_ID) {
                let course = accelerator.courses.find(course => course.ID === THIRD_COURSE_ID);
                if (course) {
                    navigate(removeDomainFromUrl(course.lessons[0].url))
                }
            } else if (evaluationAnswer === "Straight Push" && currentLesson.courseID !== FOURTH_COURSE_ID) {
                let course = accelerator.courses.find(course => course.ID === FOURTH_COURSE_ID);
                if (course) {
                    navigate(removeDomainFromUrl(course.lessons[0].url))
                }
            } else if (evaluationAnswer === "Straight Pull" && currentLesson.courseID !== FIFTH_COURSE_ID) {
                let course = accelerator.courses.find(course => course.ID === FIFTH_COURSE_ID);
                if (course) {
                    navigate(removeDomainFromUrl(course.lessons[0].url))
                }
            }
        }
    }

    const endLesson = () => {
        setIsVideoPlaying(false);
        setLessonComplete({
            lessonID: currentLesson.ID,
            courseID: currentLesson.courseID,
            wasComplete: currentLesson.complete
        });

        const courseLessons = courses.find(el => el.ID === currentLesson.courseID);
        let nextCourseLesson = null;

        if (courseLessons) {
            if (evaluationAnswer === "Left of hole" && Number(currentLesson.ID) === PUTTING_LESSON_ID) {
                nextCourseLesson = courseLessons.lessons.find((el, index) => Number(el.ID) === PUTTING_LEFT_LESSON_ID);
            } else if (evaluationAnswer === "Push Slice" && Number(currentLesson.ID) !== COURSE_ONE_LESSON_ID) {
                nextCourseLesson = null;
            } else if (evaluationAnswer === "Pull Slice" && Number(currentLesson.ID) !== COURSE_TWO_LESSON_ID) {
                nextCourseLesson = null;
            } else if (evaluationAnswer === "Pull Hook" && Number(currentLesson.ID) !== COURSE_THREE_LESSON_ID) {
                nextCourseLesson = null;
            } else if (evaluationAnswer === "Straight Push" && Number(currentLesson.ID) !== COURSE_FOUR_LESSON_ID) {
                nextCourseLesson = null;
            } else if (evaluationAnswer === "Straight Pull" && Number(currentLesson.ID) !== COURSE_FIVE_LESSON_ID) {
                nextCourseLesson = null;
            } else
                nextCourseLesson = courseLessons.lessons.find((el, index) => currentLesson.ordinal + 1 <= index && (el.lesson_type === 'video'));
        }
        let currentCourseIndex = courses.findIndex(el => el.ID === currentLesson.courseID);
        let currentAcceleratorIndex = accelerators.findIndex(el => el.ID === accelerator.ID);
        if (nextCourseLesson) {
            showNextLessonInCourseModal(nextCourseLesson);
        } else if (courses.length > currentCourseIndex + 1) {
            for (let i = currentCourseIndex + 1; i < courses.length; i++) {
                let newCourse = courses[i];
                nextCourseLesson = newCourse.lessons.find((el) => el.lesson_type === 'video');
                if (nextCourseLesson) {
                    showNextLessonInCourseModal(newCourse.lessons[0]);
                    break;
                }
            }
        } else if (currentAcceleratorIndex + 1 < accelerators.length) {
            showNextAcceleratorModal(accelerators[currentAcceleratorIndex + 1]);
        }
    }
    useEffect(()=>{

    },[currentLesson])
    const showNextAcceleratorModal = (accelerator: Accelerator) => {
        setModalTitle(isMobile ? MOVE_TO_NEXT_ACCELERATOR_MOBILE : MOVE_TO_NEXT_ACCELERATOR);
        setModalBtnText(accelerator.name)
        setModalAction(() => () => playNextAccelerator(accelerator));
        setShowModal(true);
    }

    const showNextLessonInCourseModal = (lesson: Lesson) => {
        /*if (isMobile) {
            setShowModal(false);
            return;
         };*/
        let champCount = parseInt(localStorage.getItem('nextModalChampCounter') || "0");
        champCount++;
        localStorage.setItem(`nextModalChampCounter`, champCount.toString());
        const hasChamp = window.pgUser?.products?.some((product: string) => product === '125' || product === '124')
      if (champCount % 4 === 0 && !hasChamp) {
         setCurrentPromo(CHAMPION_PASS_PROMO)
         console.log("next is showing champ pass!!!!!!")
      }
        if (isTrainingDrill) {
            setModalTitle(isMobile ? RECORD_DRILL_RESULTS_MOBILE : RECORD_DRILL_RESULTS);
        } else {
            setModalTitle(isMobile ? MOVE_TO_NEXT_LESSON_MOBILE : MOVE_TO_NEXT_LESSON);
        }
        setModalBtnText(lesson.name)
        setModalAction(() => () =>
            playNextLesson(lesson)
        );
        setShowModal(true);
    }

    const openRecordResultDialog = (event: any, lesson: Lesson) => {
        event.stopPropagation();
        if (lesson.drill) {
            if (isMobile) {
                setScrollOffset(window.scrollY);
                document.body.style.touchAction = 'none'
                document.body.style.position = 'fixed';
                document.body.style.top = -scrollOffset + 'px';
            }
            setRecordResult(true);
            setRecordLesson(lesson);
        }
    }

    const handleCloseDialog = () => {
        if (isMobile) {
            document.body.style.touchAction = 'auto';
            document.body.style.position = 'unset';
            window.scrollTo(0, scrollOffset)
        }
        setResultsDialogOpen(false);
    };

    const playNextAccelerator = (accelerator: Accelerator) => {
        let currentAcceleratorIndex = accelerators.findIndex(el => el.ID === accelerator.ID);
        const regExp = /\/([^/?]+\/[^/?]+)\/$/;
        let path = accelerators[currentAcceleratorIndex].url.match(regExp);
        if (path)
            navigate(path[0]);

        // let path = accelerators[currentAcceleratorIndex].url.replace(window.location.origin, '');
        if (path)
            navigate(path[0]);
        setShowModal(false);
        setShowPopupDialog(false);

        
    }



    const playNextLesson = (lesson: Lesson) => {
        navigate(isDrillsPath(location.pathname) ? removeDomainFromUrl(lesson.drill_redirect_url) : removeDomainFromUrl(lesson.url));
        setShowModal(false);
        setShowPopupDialog(false);

        
    }
    const [showVideoEnd, setShowVideoEnd] = useState(false);

 

    const renderPlaylist = courses.map((course, index) => {
        return <Playlist key={index}
                        totalVideoPlayerHeight={totalVideoPlayerHeight}
                        isShowCoachBanner={isShowCoachBanner}
                        updateLessonCounter={updateLessonCounter}
                         accelerator={accelerator}
                         course={course}
                         index={index}
                         currentLesson={currentLesson}
                         lessonComplete={lessonComplete}
                         setShowModal={(value: boolean) => setShowModal(value)}
                         expanded={expanded}
                         setExpanded={setExpanded}
                         playerTitleHeight={playerTitleHeight}
                         playerHeight={playerHeight}
            // @ts-ignore
                         playerRef={containerRef}
                         recordResultHeight={recordResultHeightNumber}
                         videoLoaded={videoLoaded}
                         evaluationAnswer={evaluationAnswer}
                         firstTime={firstTime}
                         showVideoEnd={showVideoEnd}
                         updateDrillLessons={updateDrillLessons}
                         autoplayNextForCourse={autoplayNextForCourse}
                         setAutoplayNextForCourse={setAutoplayNextForCourse}
                         isInViewPortScrollableContainer={firstVisibleIndex === index}
                         onSwitchAnchorMount={handleSwitchMount}
                         handleAutoplayToggle={handleAutoplayToggle}
                         prevNextHeight={prevNextHeight}
        />
    });

    const hideTitle = () => {
        setHiding(false);
    };

    const showTitle = () => {
        setHiding(true);
    };

    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const [firstVideoPlay, setFirstVideoPlay] = useState(false);


    const handleVideoPlay = () => {
        setIsVideoPlaying(true);
        // console.log("course id: ", currentLesson.courseID);
        // if (isMobile) {
        //     setExpanded(currentLesson.courseID);
        //     setTimeout(() => {
        //         const playingLessonId = currentLesson.ID;
        //         const playingLessonElement = document.querySelector(`#lesson-element-${playingLessonId}`)
        //         if (playingLessonElement) {
        //             const elementTop = playingLessonElement.getBoundingClientRect().top + window.scrollY;
        //             const offset = totalVideoPlayerHeight || 0; 
        //             window.scrollTo({
        //                 top: elementTop - offset,
        //                 behavior: "smooth",
        //             });
        //         }
        //     }, 300);
        // }
        if (!firstVideoPlay) {
            const currentDate = getCurrentDate();
            const updatedCount = videoCompletionCount + 1;

            // Update the count in state and localStorage
            setVideoCompletionCount(updatedCount);
            localStorage.setItem(`videoCompletionCount_${currentDate}`, updatedCount.toString());
            setFirstVideoPlay(true);
        }
    };

    const handleVideoPause = () => {
        setIsVideoPlaying(false);
    };

    const [currentWatchTime, setCurrentWatchTime] = useState<number>(0);
    useEffect(() => {
        let interval: ReturnType<typeof setInterval> | null = null;

        if (isVideoPlaying) {
            interval = setInterval(() => {
                setCurrentWatchTime(prev => prev + 1);
            }, 1000);
        } else {
            setCurrentWatchTime(0);
            if (interval) clearInterval(interval);
        }

        return () => {
            if (interval) clearInterval(interval);
        };
    }, [isVideoPlaying]);

    const trackWatchTime = () => {
        if (currentWatchTime && currentWatchTime > 0) {
            totalTimeWatched(
            currentWatchTime,
            accelerator,
            currentLesson
            );
        }
    };
    useEffect(() => {
        const handlePageHide = () => {
            trackWatchTime();
        };

        window.addEventListener('pagehide', handlePageHide);

        return () => {
            window.removeEventListener('pagehide', handlePageHide);
        };
    }, [currentWatchTime]);


    //code for promo

    const [currentPromo, setCurrentPromo] = useState<Promo | null>(null);

    //shuffle promo for showing
    const shuffleArray = (array: Promo[]): Promo[] => {
        if(!array)return[]
        const newArray: Promo[] = array.slice();
        for (let i = newArray.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
        }
        return newArray;
      };

    //   useEffect(() => {
    //     // Shuffle the promo array
    //     const shuffledPromos = shuffleArray(window.pgPromo);

    //     // Take the first promo from the shuffled array
    //     const firstPromo = shuffledPromos[0];

    //     // Set the current promo in the state
    //     setCurrentPromo(firstPromo);
    //   }, [window.pgPromo, currentLesson]);


// ## no shuffling but in order
    // const cycleThroughPromos = (array: Promo[], currentIndex: number): Promo => {
    //     const newIndex = (currentIndex + 1) % array.length;
    //     return array[newIndex];
    //   };

    //   const [currentPromoIndex, setCurrentPromoIndex] = useState(0);

    //   useEffect(() => {
    //     // Initialize current promo index in state


    //     // Function to handle cycling through promos
    //     const cyclePromos = () => {
    //       // Get the current promo from the array based on the index
    //       const currentPromo = cycleThroughPromos(window.pgPromo, currentPromoIndex);

    //       // Update current promo index for the next cycle
    //       setCurrentPromoIndex((prevIndex) => (prevIndex + 1) % window.pgPromo.length);

    //       // Set the current promo in the state
    //       setCurrentPromo(currentPromo);
    //     };

    //     // Randomize the starting index whenever currentLesson changes
    //     setCurrentPromoIndex(Math.floor(Math.random() * window.pgPromo.length));

    //     // Call cyclePromos once to initialize the current promo
    //     cyclePromos();

    //     // Call cyclePromos whenever the currentLesson changes
    //     return () => {
    //       // Cleanup if necessary
    //     };
    //   }, [window.pgPromo, currentLesson]);


      const [shuffledPromos, setShuffledPromos] = useState<Promo[]>([]);
      const [promoIndex, setPromoIndex] = useState<number>(0);
      const [resetBanner, setVideoBanner] = useState<boolean>(false);


      useEffect(() => {
        // Shuffle the promo array when it changes or on initial render
        const updatedPromos = window.pgPromo || dummyPgPromo
        setShuffledPromos(shuffleArray(updatedPromos));
        // Reset promo index
        setPromoIndex(0);
      }, [window.pgPromo]);

      useEffect(() => {
        // Get the current promo from the shuffled array
        const currentPromo = shuffledPromos[promoIndex];

        // Increment promo index for the next cycle
        setPromoIndex((prevIndex) => prevIndex + 1);

        // If all promos have been shown, shuffle the array again
        if (promoIndex === shuffledPromos.length) {
            const updatedPromos = window.pgPromo || dummyPgPromo
            setShuffledPromos(shuffleArray(updatedPromos));
            setPromoIndex(0);
        }

            setCurrentPromo(currentPromo);

      }, [shuffledPromos, currentLesson, resetBanner, addToPlaylist]);

    //if nextlesson is 4 then show champ pass
    // useEffect(()=> {
    //     let champCount = parseInt(localStorage.getItem('nextModalChampCounter') || "0");
    //     const hasChamp = window.pgUser?.products?.some((product: string) => product === '125' || product === '124')
    //     if (champCount % 4 === 0 && !hasChamp) {
    //     setCurrentPromo(CHAMPION_PASS_PROMO)
    //     console.log("next is showing champ pass!!!!!!")
    //     }
    // }, [showModal]);


      const [videoCompletionCount, setVideoCompletionCount] = useState(0);
      const [viewProductCalled, setViewProductCalled] = useState(false);
      const [prevVideoId, setPrevVideoId] = useState<number | null>(null);
      const [oldStoredCount, setOldStoredCount] = useState(0);

      const getCurrentDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

    const allCoursesCompleted = courses.every(course => {
        const courseProgress = course.progress;
        return courseProgress === 100;
    });

    useEffect(() => {
        const currentDate = getCurrentDate();
        const storedCount = parseInt(localStorage.getItem(`videoCompletionCount_${currentDate}`) || '0', 10) || 0;
        setVideoCompletionCount(storedCount);
    }, [videoCompletionCount, allCoursesCompleted, currentPromo]);

    useEffect(() => {
        const currentDate = getCurrentDate();
        const storedCount = parseInt(localStorage.getItem(`videoCompletionCount_${currentDate}`) || "0", 10) || 0;
        const lessonID = parseInt(localStorage.getItem('modalLessonID') || "0");
        setVideoCompletionCount(storedCount);

        // Check if the count is 6 and show the modal
        //slobodan
        let champCount = parseInt(localStorage.getItem('champFourCounter') || "0");
        if (storedCount !== 0 && storedCount % 6 === 0 && currentPromo && (lessonID === currentLesson.ID || lessonID === 0) && storedCount !== oldStoredCount ) {
            localStorage.setItem(`modalLessonID`,currentLesson.ID.toString());
            champCount++;
            const hasChampPass = window.pgUser?.products?.some((product: string) => product === '124' || product === '125')
            let triggerSplitCh = false;

            // counter for champ on every 4
            if (champCount === 4 && !hasChampPass) {
                console.log("champcount 4!!!!")
                const updatedPromos =  CHAMPION_PASS_PROMO
                setCurrentPromo(updatedPromos);
                champCount = 0;
                triggerSplitCh = true;
            }

            if (videoLoaded) {
                //setShowPopupDialog(true);
                setShowModal(false);
                localStorage.setItem(`modalLessonID`,currentLesson.ID.toString());

                if (triggerSplitCh) {
                    if (window.championsPassTrialPricing) {
                        viewChampionPassModal('Video', 'Pop Up', '', "In Video", currentPromo.name,"WE603");
                    } else {
                        viewChampionPassModal('Video', 'Pop Up', '', "In Video", currentPromo.name, null);
                    }
                    triggerSplitCh = false;
                }

            }
            console.log("champ count is >> ", champCount)
            localStorage.setItem('champFourCounter', champCount.toString());
        } else {
            localStorage.setItem(`modalLessonID`,"0");
            setOldStoredCount(storedCount)
        }

        if (allCoursesCompleted && currentPromo) {
           //setAddToPlaylist(true);

           if(videoLoaded) {
                //setShowPopupDialog(true);
                setShowModal(false);
           }
        }
     }, [currentLesson]);

     // adding video views on changing the lesson
     useEffect(()=>{
        // const currentDate = getCurrentDate();
        // if(currentLesson.ID !== 0){
        //    const updatedCount = videoCompletionCount + 1;
        //    localStorage.setItem(
        //       `videoCompletionCount_${currentDate}`,
        //       updatedCount.toString()
        //    );
        //    setVideoCompletionCount(updatedCount);
        // //    console.log("setting the updated count >> ", updatedCount)
        // }
        setFirstVideoPlay(false);
        // console.log("current lesson id >> ", currentLesson.ID)
     },[currentLesson.ID])

    useEffect(() => {
        // Trigger viewProduct only if it hasn't been called yet
        if ( currentPromo && showModal) {
            viewProduct("Video", "Banner", "", "End of Video", currentPromo.name);

        //   console.log("in the viewprodcalled useeffect!!!!!!!", viewProductCalled)
        }
        setViewProductCalled(false)
    }, [showModal]);


    if(currentLesson.cta) {
        currentLesson.cta.url = currentLesson.cta.url.replace('first_name=&', `first_name=${window.pgUser?.first_name}&`);
        currentLesson.cta.url = currentLesson.cta.url.replace('last_name=&', `last_name=${window.pgUser?.last_name}&`);
        currentLesson.cta.url = currentLesson.cta.url.replace('email=&', `email=${window.pgUser?.user_email}&`);
    }

    useEffect(()=>{
        updateLessonCounter();
    },[currentLesson])

    //scroll upnext in playlist
    useEffect(() => {
        const scrollToFinalOffer = () => {
            if (myRef.current) {
                //@ts-ignore
                myRef.current.scrollToBottom();
              }else {
                console.error("upNextPlaylistRef.current is null desktop");
            }
        };

        // const scrollMobileOffer = () => {
        //     if (upNextPlaylistRef.current) {
        //         upNextPlaylistRef.current.scrollIntoView({
        //             behavior: "auto",
        //             block: "start"
        //         })
        //       }
        //       else {
        //         console.error("upNextPlaylistRef.current is null.");
        //     }
        // };


        const scrollMobileOffer = () => {
            setTimeout(() => {
            const upNextElement = document.getElementById('upNext');
            if (upNextElement) {
                // upNextElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
                const headerHeight = playerHeight + playerTitleHeight;
                const elementPos = upNextElement.offsetTop - headerHeight
                // const scrollToPosition = elementPos > 800? elementPos + headerHeight : elementPos - headerHeight;
                const scrollToPosition =  elementPos;
                console.log("element top >> ", upNextElement.offsetTop)
                console.log("position to scroll >> ", scrollToPosition)

                    window.scroll({ top: scrollToPosition, behavior: 'smooth' });

            }
            }, 500);
        };

        !isMobile&&scrollToFinalOffer();
        isMobile&&scrollMobileOffer()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addToPlaylist]);

    // console.log(isInitailVideoPlay,"isInitailVideoPlay")


    return <>
        <Grid container columnSpacing={3}
              sx={{
                  // marginBottom: {xs: quickDrillsHeight + 2 + "px", md: 0}
              }}>
            <Grid item xs={12} md sx={{
                position: 'relative',
                zIndex: 1
            }}>
                <Box sx={{
                    position: {xs: "sticky", md: "relative"},
                    top: 0,
                    zIndex: 5
                }} onMouseEnter={showTitle} onMouseLeave={hideTitle}>
                    <Typography
                        ref={playerTitleRef}
                        textTransform={"uppercase"}
                        fontSize={{ xs: "12px", md: "14px" }}
                        fontFamily={'Repro Mono'}
                        style={{display: videoLoaded ? "block" : "none"}}
                        m={0}
                        p={1}
                        color={"#ffffff"}
                        textAlign={"center"}
                        sx={{
                            backgroundColor: {
                              xs: "rgba(0, 0, 0, 0.8) ",
                              md: "#1D1A1A",
                            },
                            ...(isVideoPlaying && {opacity: !hiding && !isMobile ? 0 : 1}),
                            ...(!isVideoPlaying && {opacity: 1}),
                        }}
                        id={`lesson-banner-${currentLesson.ID}`}
                    >
                        {!currentLesson.content &&
                            <Box component={"img"}
                                 sx={{marginRight: "7px", paddingBottom: "2px"}}
                                 src="https://www.performancegolf.com/wp-content/uploads/2023/11/Video-Icon.png"
                                 alt="play"/>
                        }
                        {parse(currentLesson.name)} {!currentLesson.content && currentLesson.duration}

                    </Typography>

                    <Box className={styles.videoModalContainer} ref={containerRef}
                         sx={{scrollMarginTop: playerTitleHeight}}
                    >
                        {showModal && !showPopupDialog && (
                        <>
                        {/* not using viewProductCalled anymore in useEffect for the event */}
                        {!viewProductCalled && (() => { setViewProductCalled(true); return null; })()}                            
                                <NextLessonModal
                                    playerTitleHeight={playerTitleHeight}
                                    playerHeight={playerHeight}
                                    accelerator={accelerator}
                                    modalTitle={modalTitle}
                                    modalAction={modalAction}
                                    modalBtnText={modalBtnText}
                                    currentLesson={currentLesson}
                                    promo={currentPromo && currentPromo}
                                    callback={(showOrNot: boolean) => {
                                        setShowModal(showOrNot);
                                    }}
                                    handleReplay={handleReplay}
                                    autoplayNextForCourse={autoplayNextForCourse}
                                    setAutoplayNextForCourse={setAutoplayNextForCourse}
                                    source={"sc"}
                                />
                        </>
                        )}
                        {!currentLesson.content && currentLesson.video.ID &&

                            <Vimeo
                                color="fd3300"
                                key={`vimeo-${currentLesson.video.ID}-${showModal}`}
                                controls={showModal ? false : true}
                                style={{background: "transparent"}}
                                showTitle={false}
                                video={currentLesson.video.ID}
                                responsive={true}
                                playsInline={true}
                                autoplay={!isMobile && !isIOS() && !isInitailVideoPlay && autoplayNextForCourse && (!isEndOfTheLesson || prevVideoId !== currentLesson.video.ID)}
                                onLoaded={(event) => {
                                    setTimeout(() =>
                                        setVideoLoaded(true), 500)
                                }}
                                onTimeUpdate={onProgressUpdate}
                                onEnd={(event: EndEvent) => {
                                    let vip = (currentLesson.lesson_type ==="cta" || currentLesson.cta ) ? "Yes" : "No";
                                    setVideoBanner(false);
                                    endLesson();
                                    lessonVideoCompleteEvent(event.seconds, accelerator, currentLesson, vip);
                                    // const updatedCount = videoCompletionCount + 1;
                                    // localStorage.setItem('videoCompletionCount', updatedCount.toString());
                                    // setVideoCompletionCount(updatedCount);
                                    // const currentDate = getCurrentDate();
                                    // const updatedCount = videoCompletionCount + 1;

                                    // // Update the count in state and localStorage
                                    // setVideoCompletionCount(updatedCount);
                                    setShowVideoEnd(true);
                                    // localStorage.setItem(`videoCompletionCount_${currentDate}`, updatedCount.toString());
                                    setPrevVideoId(currentLesson.video.ID);
                                    setIsEndOfTheLesson(true);
                                }}
                                onPause={(event: PauseEvent) => {
                                    handleVideoPause();
                                    if (event.seconds && event.seconds.toFixed(0) !== event.duration.toFixed(0)) {
                                        !currentLesson.drill ? pausedVideoEvent(event.seconds, accelerator, currentLesson) : pausedDrillVideoEvent(event.seconds, currentLesson)
                                    }
                                    if(currentWatchTime && currentWatchTime > 0) {
                                        totalTimeWatched(
                                            currentWatchTime,
                                            accelerator,
                                            currentLesson
                                        );
                                    }
                                }}
                                onPlay={(event: PlayEvent) => {
                                    handleVideoPlay();
                                    if (event) {
                                        let vip = (currentLesson.lesson_type ==="cta" || currentLesson.cta ) ? "Yes" : "No";
                                        !currentLesson.drill ? startedVideoEvent(event.seconds, accelerator, currentLesson, vip) : startedDrillVideoEvent(event.seconds, currentLesson);
                                        setShowVideoEnd(false);
                                    if (prevVideoId === currentLesson.video.ID) {
                                        setVideoBanner(true);
                                        setShowModal(false);
                                        setShowPopupDialog(false);
                                    }
                                        checkCurretViewMode();
                                    }
                                    setIsEndOfTheLesson(false);
                                    // const currentDate = getCurrentDate();
                                    // const updatedCount = videoCompletionCount + 1;

                                    // // Update the count in state and localStorage
                                    // setVideoCompletionCount(updatedCount);
                                    // localStorage.setItem(`videoCompletionCount_${currentDate}`, updatedCount.toString());
                                }}
                                ref={vimeoPlayerRef}
                            />
                           
                        }
                        {currentLesson.content &&
                            <img src={currentLesson.content} style={{width: '100%', height: `${containerRef}px`}}
                                 alt="not found"/>
                        }

                    </Box>
                    {isDrillsPath(location.pathname) && (
    <Box
        ref={recordResultHeightRef}
        fontSize={{ xs: "12px", md: "16px" }} // Ovde se menja font za xs na 12px
        style={{ display: videoLoaded ? "flex" : "none" }}
        m={0}
        p={1}
        color={"#ffffff"}
        sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: { xs: "#121211", md: "rgba(0, 0, 0, 0.8)" },
            ...(isVideoPlaying && { opacity: !hiding && !isMobile ? 0 : 1 }),
            ...(!isVideoPlaying && { opacity: 1 }),
        }}
    >
        <Typography
            variant="subtitle1"
            component="span"
            sx={{
                textDecoration: "underline",
                textUnderlineOffset: "4px",
                marginRight: 0,
                textDecorationThickness: "1px",
                cursor: "pointer",
                fontSize: { xs: "12px", md: "16px" } // Ovde se menja font za xs na 12px
            }}
            onClick={(event) => openRecordResultDialog(event, currentLesson)}
        >
            Game Rules
        </Typography>
        <Typography component="span" sx={{ marginX: "4px", fontSize: { xs: "12px", md: "18px" } }}>
            |
        </Typography>
        <Typography
            variant="subtitle1"
            component="span"
            sx={{
                textDecoration: "underline",
                textUnderlineOffset: "4px",
                marginLeft: 0,
                textDecorationThickness: "1px",
                cursor: "pointer",
                fontSize: { xs: "12px", md: "16px" } // Ovde se menja font za xs na 12px
            }}
            onClick={(event) => openRecordResultDialog(event, currentLesson)}
        >
            Scoring System
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Button
            variant="contained"
            sx={{
                backgroundColor: "#355ADD",
                "&:hover": {
                    backgroundColor: "#163190",
                },
            }}
            onClick={(event) => openRecordResultDialog(event, currentLesson)}
        >
            <Typography fontSize={{ xs: "10px", md: "14px" }} fontWeight={700}>
                Record results
            </Typography>
        </Button>
    </Box>
)}


                    {!videoLoaded && !currentLesson.content &&
                        <Box sx={{
                            display: "flex",
                            position: "absolute",
                            backgroundColor: "#ffffff",
                            height: "101%",
                            width: "100%",
                            top: 0,
                            left: 0
                        }}>
                            <Spinner sx={{margin: "auto"}}/>
                        </Box>
                    }

                    {showPopupDialog &&
                    <>
                    {currentPromo?.ID === 124 ?
                (
                    <></>
                ):(isMobile ?  (

                    <PopUpDialogMobile
                    showPop={showPopupDialog}
                    accelerator={accelerator}
                    accelName = {accelerator.name}
                    source = {"player"}
                    currentLesson={currentLesson}
                    promo = {currentPromo}
                    callback={(showOrNot:boolean) => {
                        setShowPopupDialog(showOrNot);
                    }}
                    scratchClubPage = {true}
                   />
                ):(
                    <PopUpDialog
                    accelerator={accelerator}
                    accelName = {accelerator.name}
                    source = {"player"}
                    currentLesson={currentLesson}
                    promo = {currentPromo}
                    callback={(showOrNot:boolean) => {
                        setShowPopupDialog(showOrNot);
                    }}
                    scratchClubPage = {true}
                />)
                )
                }
                    </>


                        // <Box top="center" left="center" className={styles.lessonModal}>
                        //     <Box className={styles.modalHeader}>
                        //         {!isMobile ? parse(modalTitle) :
                        //             <Fragment>
                        //                 <img className={styles.modalLogo}
                        //                      src="https://www.performancegolf.com/wp-content/uploads/2023/11/Vector-1.png"
                        //                      alt="logo"/>
                        //                 <img className={styles.modalCloseBtn}
                        //                      onClick={() => setShowModal(false)}
                        //                      src="https://www.performancegolf.com/wp-content/uploads/2023/11/close_btn.png"
                        //                      alt="close"/>
                        //             </Fragment>
                        //         }
                        //     </Box>
                        //     <Box className={styles.modalBody}>
                        //     <div className={styles.ribbon}
                        //     >
                        //         <span>RECOMMENDED FOR YOU</span>
                        //     </div>
                        //         <Typography className={styles.modalText}
                        //                     fontSize={35}
                        //                     fontWeight={700}
                        //                     marginBottom={{xs: "50px", md: "30px"}}>{parse(modalTitle)}</Typography>
                        //         <Grid container padding={0} margin={0}>
                        //             <Grid item md={12} xs={12} padding={0} margin={0}>
                        //             <Typography sx={{fontWeight: 700, whiteSpace: "nowrap"}}>We see that you are working on</Typography>
                        //             <Typography sx={{fontWeight: 700, whiteSpace: "nowrap"}}>{parse(currentLesson.name)}</Typography>
                        //             </Grid>
                        //             <Grid item md={6} xs={12} padding={0} margin={0} paddingLeft={{xs: 0, md: "10px"}}>

                        //             </Grid>
                        //         </Grid>
                        //         <Grid container padding={0} margin={0} sx={{position:"relative", marginTop:"30px", backgroundColor: 'rgba(255, 255, 255, 0.6)', display: 'flex', flexDirection: 'column', paddingBottom:"20px"}}>


                        //         </Grid>
                        //     </Box>
                        // </Box>
                    }
                </Box>
                {(prevVideoLesson || nextVideoLesson) && !isMobile767 && (
                    <Box
                        ref={prevNextRef}
                        sx={{
                        display: "flex", flexWrap: "wrap", alignItems: "stretch",
                        position: isMobile ? "sticky" : "relative",
                        scrollMarginTop: isMobile
                            ? `${playerTitleHeight + playerHeight}px`
                            : 0,
                        top: isMobile
                            ? `${playerTitleHeight + playerHeight}px`
                            : 0,
                        zIndex: "5",
                        backgroundColor: "#fff"
                        }}
                    >  
                        {prevVideoLesson?.url && (
                        <Box
                            sx={{
                                flex: '1 1 50%',
                                '&:only-child': {
                                    flex: '1 1 100%',
                                }
                            }}>
                            <button onClick={() => { playNextLesson(prevVideoLesson) }} style={{
                                display: "flex",
                                padding: "18px",
                                border: "1px solid #E8E8E8",
                                background: "transparent",
                                width: "100%",
                                gap: "17px",
                                height: "100%",
                                alignItems: "center",
                                justifyContent: nextVideoLesson ? "flex-start" : "space-between",
                                flexDirection: nextVideoLesson ? "row" : "row-reverse",
                            }}>
                                <Box
                                    sx={{
                                    position: 'relative',
                                    width: '84px',
                                    maxHeight: "50px",
                                    minWidth: "84px"
                                    }}
                                >
                                    <Box
                                    component="img"
                                    src={prevVideoLesson?.lesson_thumbnail_image}
                                    sx={{
                                        width: '100%',
                                        borderRadius: '3px',
                                        display: 'block',
                                        maxHeight: "50px",
                                    }}
                                    />
                                    <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        width: '24px',
                                        height: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                    }}
                                    >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="white" fill-opacity="0.6"/>
                                        <path d="M10.8 12L15.4 16.6L14 18L8 12L14 6L15.4 7.4L10.8 12Z" fill="#FD3300"/>
                                    </svg>
                                    </Box>
                                </Box>
                                <Box sx={{
                                    textAlign: "left"
                                }}>
                                    <Typography sx={{
                                    color: "#E8330A",
                                    fontFamily: "Repro Mono",
                                    fontSize: "14px",
                                    letterSpacing: "1.4px"
                                    }}>
                                    ← PREVIOUS
                                    </Typography>
                                    <Typography sx={{
                                    color: "#121212",
                                    fontFamily: "Repro",
                                    fontSize: "16px",
                                    fontWeight: "700"
                                    }}>
                                    {prevVideoLesson.name}
                                    </Typography>
                                </Box>
                            </button>
                        </Box>
                        )}
                        {nextVideoLesson?.url && (
                        <Box
                            sx={{
                                flex: '1 1 50%',
                                '&:only-child': {
                                    flex: '1 1 100%',
                                },
                            }}>
                            <button onClick={() => { playNextLesson(nextVideoLesson) }} style={{
                                display: "flex",
                                padding: "18px",
                                border: "1px solid #E8E8E8",
                                background: "transparent",
                                justifyContent: "space-between",
                                width: "100%",
                                gap: "17px",
                                height: "100%",
                                alignItems: "center",
                            }}>
                                <Box sx={{
                                    textAlign: "left"
                                }}>
                                    <Typography sx={{
                                    color: "#E8330A",
                                    fontFamily: "Repro Mono",
                                    fontSize: "14px",
                                    letterSpacing: "1.4px"
                                    }}>
                                    {!prevVideoLesson ? "NEXT VIDEO →" : "NEXT →"}
                                    </Typography>
                                    <Typography sx={{
                                    color: "#121212",
                                    fontFamily: "Repro",
                                    fontSize: "16px",
                                    fontWeight: "700"
                                    }}>
                                    {nextVideoLesson.name}
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                    position: 'relative',
                                    width: '84px',
                                    maxHeight: "50px",
                                    minWidth: "84px"
                                    }}
                                >
                                    <Box
                                    component="img"
                                    src={nextVideoLesson?.lesson_thumbnail_image}
                                    sx={{
                                        width: '100%',
                                        borderRadius: '3px',
                                        display: 'block',
                                        maxHeight: "50px",
                                    }}
                                    />
                                    <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        width: '24px',
                                        height: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                    }}
                                    >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="white" fill-opacity="0.6"/>
                                        <path d="M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z" fill="#FD3300"/>
                                    </svg>
                                    </Box>
                                </Box>
                            </button>
                        </Box>
                        )}
                    </Box>
                )}
                {isMobile && <>
                    <Box className={styles.accordionContainer} sx={{}}>
                        <Box className={`${styles.accordion} playListLessons`}>
                            {renderPlaylist}
                        </Box>
                    </Box>
                    {currentPromo && addToPlaylist &&
                        <div id="upNext">
                            <UpNext
                                promo={currentPromo}
                                //@ts-ignore
                                accelerator={accelerator}
                                lesson={currentLesson}
                            />
                        </div>
                    }
                    </>
                }
            </Grid>

            {!isMobile &&
            <Grid item md={4} sx={{height: {xs: "100vh", md: "auto", minWidth: "412px", zIndex: 1}}}>
                <Scrollbar ref={myRef} style={{width: '100%', height: '100%'}} noScrollX={true}>
                        <Box className={styles.accordion}>{renderPlaylist}
                        {currentPromo && addToPlaylist &&
                            <UpNext
                                promo={currentPromo}
                                accelerator={accelerator}
                                lesson={currentLesson}
                            />
                        }</Box>
                </Scrollbar>
            </Grid>
            }
        </Grid>
       

            <ResultsDialog
                open={resultsDialogOpen}
                onClose={handleCloseDialog}
                onButton1Click={() => {
                    document.body.style.touchAction = 'auto';
                    document.body.style.position = 'unset';
                    navigate("/scratch-club/record", {state: {id: recordLesson}})
                }}
                onButton2Click={handleCloseDialog}
            />

            <RecordResultsDialog
                show={recordResult}
                setShow={(value) => setRecordResult(value)}
                lesson={recordLesson}
                callback={(data) => {
                    setResultsDialogOpen(true)
                    if(updateDrillLessons){
                        updateDrillLessons(recordLesson.ID, data);
                    }
                }}
            />
    </>;
};

export default Player;
